import { AscImageSource } from '../models/utility-types';

export function getImageSource(image: AscImageSource) {
  if (typeof image === 'string') {
    return image;
  }
  return image?.src;
}
